import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-业主用户",
  "use": "icon-业主用户-usage",
  "viewBox": "0 0 201.2 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 201.2 200\" id=\"icon-业主用户\">\r\n<path d=\"M177.8,88.7l-62-64.5c-3.9-4-9-6.2-14.5-6.2s-10.7,2.2-14.5,6.2l-62,64.5c-6.4,6.7-5.6,12.4-4.5,14.8\r\n\tc0.8,1.7,3.3,6.4,10.6,6.4H40v49.6c0,11.3,8.1,21.9,19.6,21.9H70h16v-11.7V129c0-5.6-0.9-8.8,4.9-8.8h10.4h10.4\r\n\tc5.8,0,4.9,3.1,4.9,8.8v40.9v11.7h16H143c11.5,0,19.6-10.6,19.6-21.9V110h9.1c7.3,0,9.9-4.7,10.6-6.4\r\n\tC183.4,101.2,184.2,95.4,177.8,88.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol